
import React, { useState } from 'react';
import { Language } from '../../types';
import DocsSidebar from './DocsSidebar';
import DocsContent from './DocsContent';

interface DocsComponentProps {
  language: Language;
  onBack?: () => void;
  docsContent: any[];
}

const DocsComponent: React.FC<DocsComponentProps> = ({ language, onBack, docsContent }) => {
  const isRtl = language === 'ar';
  const [activeSection, setActiveSection] = useState('intro');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredDocs = docsContent.filter(doc => {
     const text = isRtl ? doc.title.ar : doc.title.en;
     return text.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <div className="flex h-full w-full bg-slate-50 dark:bg-[#050507] overflow-hidden relative font-sans transition-colors duration-500">
      <DocsSidebar 
        language={language}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        filteredDocs={filteredDocs}
      />
      <DocsContent 
        language={language}
        docsContent={docsContent}
        activeSection={activeSection}
        onBack={onBack}
      />
    </div>
  );
};

export default DocsComponent;
